import {useContext} from "react";

import Button from "@/components/button/Button.tsx";
import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {URL_ORIGINAL_WEBSITE} from "@/lib/links.ts";
import {StatusPageContext} from "@/pages/statuspages/statuspages-manage/ManageStatusPageTabContainer.utils.tsx";
import {StatusPageSubscribersImportActionButton} from "@/pages/statuspages/tabs/subscribers/actions/StatusPageSubscribersImportActionButton.tsx";

export const StatusPageSubscribersActionBar = () => {
  const {user} = useCurrentUserContext();
  const {statusPage} = useContext(StatusPageContext);
  return (
    <>
      {user?.has_admin_access && (
        <StatusPageSubscribersImportActionButton>Import</StatusPageSubscribersImportActionButton>
      )}
      {user?.has_admin_access && (
        <Button
          as={"a"}
          variant="secondary"
          href={`${URL_ORIGINAL_WEBSITE}/statuspages/${statusPage.id}/manage/export-subscribers`}
          target="_blank"
          referrerPolicy="no-referrer"
        >
          Export
        </Button>
      )}
    </>
  );
};
